import { Component, OnInit, Input, OnChanges, isDevMode, ViewChildren, ViewChild, QueryList, ElementRef, ChangeDetectorRef, forwardRef, OnDestroy } from '@angular/core';
import { Router } from '@angular/router';
import { FormGroup, FormBuilder, Validators, ReactiveFormsModule } from '@angular/forms';
import { ToolbarItem } from '../../interfaces/tool-bar-item.interface';
import { AuthenticationService } from '@core/services/authentication.serivce';
import { faUser } from '@fortawesome/free-regular-svg-icons';
import { faGlobe, faQuestion, faSignOut } from '@fortawesome/free-solid-svg-icons';
import { ProfilePictureService } from '@core/services/profile-picture.service';
import { ButtonModule, PopupSettings, SplitButtonModule } from '@progress/kendo-angular-buttons';
import { DialogModule, WindowService, WindowSettings } from '@progress/kendo-angular-dialog';
import { UrlSettingComponent } from '../url-setting/url-setting.component';
import { AuthUserSearchResult } from '../../interfaces/gridrows/auth-user-search-result.interface';
import { Cart } from '../../../core/interfaces/cart.interface';
import { ItemService } from '../../../modules/items/services/item-service';
import { CartService } from '../../services/cart.service';
import { SecurityRole } from '../../literals/shared.literal';
import { SVGIcon, questionCircleIcon, thumbUpIcon, xIcon } from '@progress/kendo-svg-icons';
import { INotificationService } from '../../services/inotification.service';
import { BooleanResult } from '../../../core/interfaces/boolean-result.interface';
import { HttpErrorResponse } from '@angular/common/http';
import { RedeploymentOrderService } from '../../../modules/redeployment-orders/services/redeployment-order.service';
import { AppBarModule } from '@progress/kendo-angular-navigation';
import { FontAwesomeModule } from '@fortawesome/angular-fontawesome';
import { TextBoxModule } from '@progress/kendo-angular-inputs';
import { SelectFieldComponent } from '../select-field/select-field.component';
import { IconModule, SVGIconModule } from '@progress/kendo-angular-icons';
import { SideCartComponent } from '../side-cart/side-cart.component';
import { StackLayoutModule } from '@progress/kendo-angular-layout';
import { AskForHelpComponent } from '../ask-for-help/ask-for-help.component';

@Component({
    selector: 'app-bar',
    imports: [AppBarModule,
        IconModule,
        ReactiveFormsModule,
        TextBoxModule,
        SplitButtonModule,
        FontAwesomeModule,
        ButtonModule,
        SideCartComponent,
        StackLayoutModule,
        DialogModule,
        forwardRef(() => SelectFieldComponent)],
    templateUrl: './app-bar.component.html',
    styleUrls: ['./app-bar.component.css']
})
export class AppBarComponent implements OnInit, OnChanges {

  cartItems: any;

  @Input() userName: string;
  @Input() organizationName: string;
  @Input() isVisible: boolean;

  popupSettings: PopupSettings;
  popupOganziationSettings: PopupSettings;
  submitted: boolean = false;
  menuItems: ToolbarItem[];

  helpText: string = "Help";

  helpMenuItems: ToolbarItem[];

  isAdmin: boolean = false;
  
  organizationMenuItems: any[] | undefined;
  organizationItems: ToolbarItem[] = [];

  timedOutCartItems: any;
  timedOutCartMiscItems: any;

  openTimeout: boolean = false;

  dialogNo: SVGIcon = xIcon;
  dialogYes: SVGIcon = thumbUpIcon;
  dialogLoader: boolean = false;
  dialogIcon: boolean = true;

  helpIcon: SVGIcon = questionCircleIcon;
  constructor(private router: Router,
              private service: AuthenticationService,
              private windowService: WindowService,
              private notificationService: INotificationService,
              private orderService: RedeploymentOrderService,
              private cartService: CartService) {

    var session = service.getSession();
    var value = { id: session?.organizationId, name: session?.organizationName };
  }

  ngOnInit() {

    var session = this.service.getSession();

    if (this.service.isLoggedIn()) {
      this.isVisible = true;
    } else {
      this.isVisible = false;
    }

    if (session?.securityRoleId == Number(SecurityRole.Administrator)) {
      this.isAdmin = true;
    }

    this.popupSettings = {
      popupClass: "user-popup",
      animate: true
    };

    this.popupOganziationSettings = {
      popupClass: "oganziation-popup",
        animate: true
    }

    this.organizationMenuItems = session?.organizationList;

    this.organizationMenuItems?.map(x => {

      var organizationItem: ToolbarItem = {
        text: x.Name,
        value: x.ID,
        icon: faGlobe,
        hasMultiple: false,
        action: (value, text) => { this.service.switchOrganization(value, text); }
      };

      this.organizationItems.push(organizationItem);

    });


    this.menuItems = [
      {
        text: "Profile",
        icon: faUser,
        hasMultiple: false,
        action: () => { this.redirectToUsersProfilePage() }
      },
      {
        text: "Logout",
        icon: faSignOut,
        hasMultiple: false,
        action: () => { this.service.logout(); }
      }
    ];

    this.helpMenuItems = [
      {
        text: "Contact Us",
        icon: faQuestion,
        hasMultiple: false,
        action: () => { this.openContactUs(); }
      }
    ];

    if (isDevMode()) {
      var urlPicker: ToolbarItem = {
        text: "URL Setting",
        icon: faGlobe,
        hasMultiple: false,
        action: () => { this.showUrlSettings(); }
      };

      this.menuItems.splice(1, 0, urlPicker);
    }

    if (this.userName == null) {
      this.userName = "";
    }

    var userButton = document.getElementById('btnOrganization');
    var btn = userButton?.children[0] as HTMLButtonElement;
    //btn.style.width = "auto";
    //btn.style.justifyContent = "left";
    //btn.style.fontSize = "17px";
    //btn.style.fontFamily = "Segoe UI";

    var search = document.getElementById('txtSearch') as HTMLInputElement;
    var user = document.getElementById('btnOrganization') as HTMLElement;

    if (this.isVisible) {
/*      user.style.display = "inline-flex";*/
/*      search.style.display = "inline-flex";*/
    } else {
 /*     user.style.display = "none";*/
/*      search.style.display = "none";*/
    }
  }

  ngOnDestroy(): void {
    // Need to clean up our observable subscription to avoid memory leaks 

  }

  redirectToUsersProfilePage() {
    var session = this.service.getSession();
    var url: string = "/AuthUser/Detail/" + session?.userId;
    
    window.location.replace(url);
  }

  openContactUs() {
    var e = window.event;
    e?.preventDefault();

    let x = window.scrollX;
    let y = window.scrollY;

    window.onscroll = () => {
      window.scrollTo(x, y);
    }

    setTimeout(() => {
      window.onscroll = () => { };
    });

    var options: WindowSettings = {
      title: "Ask For Help or Contact Us!",
      width: 800,
      height: 500,
      content: AskForHelpComponent,
      draggable: true,
      resizable: false,
      top: 200
    };

    const win = this.windowService.open(options);
    var componentData = win.content.instance;

    componentData.submitForm.subscribe((form: any) => {
      form.value.sourceUrl = window.location.href;
      form.value.organization = this.service.getOrganizationName();
      this.service.askForHelp(form.value).subscribe((res) => {
        if (res.wasSuccessful) {
          this.notificationService.show({ title: 'Success', type: 'success', description: 'Email sent successfully!' });
        } else {
          this.notificationService.show({ title: 'Error', type: 'error', description: 'Something went wrong!' });
        }

        win.close();
      });
    });
  }

  ngOnChanges(): void {
    var search = document.getElementById('txtSearch') as HTMLInputElement;
    var user = document.getElementById('btnOrganization') as HTMLElement;

    if (this.isVisible) {
/*      user.style.display = "inline-flex";*/
/*      search.style.display = "inline-flex";*/
    } else {
    /*  user.style.display = "none";*/
/*      search.style.display = "none";*/
    }
  }

  ngAfterViewInit(): void {

    var userButton = document.getElementById('btnOrganization');
    var btn = userButton?.children[0] as HTMLButtonElement;
  }

  navigateTo(endpoint: string) {
    this.router.navigate([endpoint]);
  }

  menuItemClick(item: ToolbarItem): void {
    if (item && item.action) {
      item.action();
    }
  }

  organizationItemClick(item: ToolbarItem): void {
    if (item && item.action) {
      item.action(item.value, item.text);
    }
  }


  showUrlSettings(): void {
    var e = window.event;
    e?.preventDefault();

    let x = window.scrollX;
    let y = window.scrollY;

    window.onscroll = () => {
      window.scrollTo(x, y);
    }

    setTimeout(() => {
      window.onscroll = () => { };
    });

    var options: WindowSettings = {
      title: 'URL Setting',
      width: 500,
      height: 200,
      content: UrlSettingComponent,
      draggable: true,
      resizable: true,
      top: 400
    };

    const win = this.windowService.open(options);

  }

  openTimeoutDialog() {
    this.openTimeout = true;
  }

  closeTimeoutDialog() {
    this.openTimeout = false;
  }

  acknowledgeTimedOutItems() {
    this.orderService.acknowledgeTimeoutItems().subscribe({
      next: (res: BooleanResult) => {
        if (res.wasSuccessful) {
          //redirect Home Page
          var baseUrl = window.location.href.replace(this.router.url, '');
          window.location.replace(baseUrl);

        } else {
          var errors = res.errors;
          this.notificationService.show({ type: 'error', title: "Error!", description: res.message });
        }
      },
      error: (e: HttpErrorResponse) => {
        var errorMsg: string = e.error;
        if (typeof e.error === "object") {
          errorMsg = e.error.title
        }
        this.notificationService.show({ title: "Error!", type: "error", description: errorMsg ?? "Something Went Wrong!" });
      }
    });
  }

  showCart(value: any) {
    this.cartService.getCartItems().subscribe((data: any[]) => {
      this.cartItems = data;
      this.cartService.getRefresh();
      this.cartService.showCart(data);

      var wrapper = document.getElementsByClassName('wrapper')[0];
      if (wrapper.className.includes("opened")) {
        //add overlay
        document.getElementById('cartOverlay')?.classList.add('k-overlay');

        //The cart items that were removed due to timeout
        this.cartService.getTimedOutCartItems().subscribe((data: any[]) => {
          this.timedOutCartItems = data;

          this.cartService.getTimedOutCartMiscItems().subscribe((data: any[]) => {
            this.timedOutCartMiscItems = data;

            //If there are items that timed out, tell the user! They must acknowledge this so they will no longer get this popup
            if (this.timedOutCartItems.length > 0 || this.timedOutCartMiscItems.length > 0) {
              this.openTimeoutDialog();
            }
          });
        });


      }
    });
  }

  checkoutRedirect(value: any) {
    var session = this.service.getSession();
    var url: string = "/Checkout";

    window.location.replace(url);
  }
}
